<template>
  <div class="white-background-section">
    <div class="container">
      <div class="underline-text d-flex justify-content-center">
        <h2 class="text">Upcoming Community Wealth Builder events</h2>
      </div>
      <div>
        <div class="results-section">
          <div class="mt-4">
            <el-row v-if="events.length > 0">
              <events-card v-for="event in events" :key="event.id" :event="event" />
            </el-row>
            <el-row v-else>
              <el-col>
                <div class="no-event-text">
                  <p>No events or webinars are available yet</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PurpleArrowRight from "@/components/assets/svg-purple-arrow-right";
import EventsCard from "@/components/platform/events-webinars/events-card";

export default {
  components: {
    EventsCard,
    "svg-purple-arrow-right": PurpleArrowRight
  },
  props: ['events'],
  data() {
    return {};
  }
};
</script>
